import React from 'react';
import { useIntl } from 'react-intl';
import type { KitSlotGroup } from 'fym-shared/src/music24/assetKinds';
import { TypedMemo } from '../../../../common/types';
import { kitMessages } from './kitMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Kit.module.scss';
/* eslint-enable css-modules/no-unused-class */

const HEADS = {
  artwork: { title: kitMessages.groupArtwork, note: kitMessages.groupArtworkNote },
  longVideos: { title: kitMessages.groupLongVideos, note: kitMessages.groupLongVideosNote },
  profiles: { title: kitMessages.groupProfiles, note: kitMessages.groupProfilesNote },
} as const;

/** One group of slots (design assets-rethink b1 `.kgrp`): Song artwork, Long videos, Profiles and links. */
const KitGroupComponent: React.FC<{ group: KitSlotGroup; children: React.ReactNode }> = ({ group, children }) => {
  const intl = useIntl();
  return (
    <section className={styles.group} data-testid={`kit-group-${group}`}>
      <div className={styles.groupHead}>
        <h3>{intl.formatMessage(HEADS[group].title)}</h3>
        <small>{intl.formatMessage(HEADS[group].note)}</small>
      </div>
      <div className={styles.grid}>{children}</div>
    </section>
  );
};

export const KitGroup = TypedMemo(KitGroupComponent);
